{
  "bot_control_center": {
    "breadcrumb": "Empresa / Atención automática",
    "title": "Centro de Control de Atención Automática",
    "loading": "Cargando el Centro de Control...",
    "load_error": "No se pudo cargar el Centro de Control.",
    "retry": "Intentar de nuevo",
    "yes": "Sí",
    "no": "No",
    "available": "Disponible",
    "unavailable": "No disponible",
    "enabled": "Habilitado",
    "disabled": "Deshabilitado",
    "assistive_ai": "IA asistiva",
    "explain": "Entender",
    "configuration": {
      "breadcrumb": "Empresa / Bot de Atención",
      "title": "Bot de Atención",
      "subtitle": "Configura el flujo, revisa cada etapa y acompaña las decisiones de la atención automática.",
      "apply_default": "Aplicar flujo predeterminado",
      "save": "Guardar configuración",
      "loading": "Cargando la configuración del bot...",
      "not_configured": "No configurado",
      "team": "Equipo de la empresa",
      "user_fallback": "Usuario {id}",
      "main_settings": "Configuraciones principales",
      "bot_active": "Bot activo",
      "bot_inactive": "Bot inactivo",
      "ok": "OK",
      "pending": "Pendiente",
      "configured": "Configurada",
      "open": "Abrir",
      "close": "Cerrar",
      "advanced_mode": "Modo avanzado",
      "action": "Acción",
      "priority": "Prioridad",
      "keywords": "Palabras",
      "summary": {
        "answers_when": "Cuándo responde el bot",
        "handoff_target": "Quién asume cuando se necesita una persona",
        "off_hours": "Qué ocurre fuera del horario",
        "default_flow": "Flujo predeterminado",
        "ready": "Listo para usar",
        "needs_configuration": "Aún necesita configuración"
      },
      "fields": {
        "enable_bot": "Activar bot de atención",
        "allow_handoff": "Permitir transferencia a un agente",
        "assignment_mode": "Cómo distribuir nuevos leads",
        "default_user": "Usuario predeterminado",
        "answer_policy": "Cuándo puede responder el bot",
        "off_hours_policy": "Política fuera del horario",
        "session_timeout": "Tiempo de sesión (min)",
        "max_retries": "Intentos antes de transferir"
      },
      "assignment_modes": {
        "default": "Usuario predeterminado",
        "queue": "Cola de usuarios",
        "bot_system": "Sistema bot"
      },
      "answer_policies": {
        "always": "Siempre",
        "business_hours_only": "Solo en horario comercial",
        "off_hours_only": "Solo fuera del horario",
        "never": "Nunca"
      },
      "off_hours_policies": {
        "queue": "Mantener en la cola",
        "keep_assigned": "Mantener responsable actual",
        "bot_only": "Dejar solo con el bot"
      },
      "weekdays": { "0": "Dom", "1": "Lun", "2": "Mar", "3": "Mié", "4": "Jue", "5": "Vie", "6": "Sáb" },
      "dependencies": {
        "kicker": "Dependencias",
        "title": "Qué influye en el comportamiento del bot",
        "business_hours": "Horarios comerciales",
        "templates": "Plantillas",
        "integrations": "Integraciones",
        "no_business_hours": "Horarios no configurados",
        "more_hours": "+{count} horarios",
        "template_count": "{count} plantilla(s) disponible(s)",
        "no_templates": "Ninguna plantilla registrada",
        "no_integrations": "Ninguna integración activa"
      },
      "alerts": {
        "bot_disabled": {
          "title": "Bot desactivado",
          "description": "El bot está configurado, pero no responderá hasta ser activado."
        },
        "business_hours_missing": {
          "title": "Horarios comerciales no configurados",
          "description": "Configura los horarios para que las reglas comerciales funcionen correctamente."
        },
        "guided_flow_incomplete": {
          "title": "Flujo guiado incompleto",
          "description": "El flujo predeterminado aún no se aplicó por completo a esta empresa."
        },
        "bot_user_missing": {
          "title": "Usuario del bot no aprovisionado",
          "description": "El usuario virtual se creará automáticamente cuando el flujo lo necesite."
        },
        "templates_missing": {
          "title": "Sin plantillas registradas",
          "description": "Los accesos directos siguen disponibles, pero no se encontró ninguna plantilla para esta empresa."
        }
      },
      "flow": {
        "kicker": "Flujo de atención",
        "title": "Cada etapa lleva a una acción del bot",
        "extra_rules": "{count} regla(s) extra",
        "when": "Cuándo ocurre",
        "action": "Qué hace el bot",
        "next": "Próximo paso",
        "main_message": "Mensaje principal",
        "preview": "Vista previa para el usuario",
        "no_message": "Sin mensaje configurado.",
        "retry_message": "Mensaje de nuevo intento",
        "retry_preview": "Vista previa del nuevo intento",
        "trigger_keywords": "Palabras que activan esta etapa",
        "trigger_keywords_example": "Ej.: hola, buenos días",
        "handoff_keywords": "Palabras que solicitan una persona",
        "handoff_keywords_example": "Ej.: persona, agente, vendedor",
        "no_technical_rule": "Ninguna regla técnica está asociada a esta etapa."
      },
      "stages": {
        "welcome": {
          "title": "Entrada inicial",
          "when": "Cuando el cliente inicia la conversación.",
          "action": "Recibe al cliente e inicia la clasificación.",
          "next": "Captura del nombre"
        },
        "capture_name": {
          "title": "Captura del nombre",
          "when": "Cuando el bot pide el nombre e interpreta la respuesta.",
          "action": "Identifica el nombre, confirma el registro y vuelve a intentar si es necesario.",
          "next": "Comprensión del interés"
        },
        "interest_prompt": {
          "title": "Comprensión del interés",
          "when": "Cuando el nombre está registrado y el bot debe comprender el interés.",
          "action": "Conduce la conversación hacia el tema de atención.",
          "next": "Solicitud de persona o continuidad"
        },
        "handoff_request": {
          "title": "Solicitud de persona",
          "when": "Cuando el cliente solicita atención humana.",
          "action": "Transfiere a un agente según la política de la empresa.",
          "next": "Agente humano"
        },
        "offhours_default": {
          "title": "Fuera del horario",
          "when": "Cuando la conversación ocurre fuera del horario comercial.",
          "action": "Explica la indisponibilidad y mantiene la atención fuera del horario.",
          "next": "Retorno en el próximo horario hábil o continuidad restringida"
        }
      },
      "states": {
        "inicio": "Inicio",
        "captura_nome": "Captura del nombre",
        "captura_interesse": "Captura del interés",
        "agendar": "Agendar",
        "fora_do_horario": "Fuera del horario",
        "encerrado": "Cerrado",
        "humano": "Atención humana"
      },
      "monitoring": {
        "kicker": "Monitoreo",
        "title": "¿Por qué el bot hizo esto?",
        "sessions": "Sesiones",
        "logs": "Logs",
        "recent_sessions": "Sesiones recientes",
        "recent_logs": "Logs recientes",
        "contact": "Contacto",
        "lead": "Lead",
        "stage": "Etapa",
        "last_activity": "Última actividad",
        "summary": "Resumen",
        "no_lead": "Sin lead",
        "view_timeline": "Ver línea de tiempo",
        "no_sessions": "Ninguna sesión reciente para esta empresa.",
        "time": "Horario",
        "inbound_message": "Mensaje recibido",
        "matched_rule": "Regla aplicada",
        "actions": "Acciones",
        "final_stage": "Etapa final",
        "no_rule": "Sin regla identificada",
        "not_identified": "No identificado",
        "no_actions": "Sin acciones registradas",
        "explain_response": "Entender respuesta",
        "no_logs": "Ningún log reciente para esta empresa.",
        "no_recent_log": "Sin log reciente",
        "session_timeline": "Sesión del bot",
        "log_timeline": "Log del bot"
      },
      "timeline": {
        "current_state": "Etapa actual",
        "last_activity": "Última actividad",
        "last_inbound": "Último mensaje recibido",
        "customer_sent": "Cliente envió",
        "state_before": "El bot estaba en la etapa",
        "rule_applied": "Regla aplicada",
        "action_executed": "Acción ejecutada",
        "state_after": "Etapa final"
      },
      "advanced": {
        "kicker": "Avanzado",
        "title": "Reglas técnicas del bot",
        "rule_count": "{count} regla(s)",
        "description": "Descripción",
        "type": "Tipo",
        "guided": "Guiada",
        "extra": "Extra",
        "system_key": "Clave del sistema",
        "no_rules": "Ninguna regla técnica registrada.",
        "technical_rule": "Regla técnica"
      },
      "actions": {
        "reply": "Responder",
        "set_context": "Actualizar contexto",
        "create_lead": "Crear o actualizar lead",
        "schedule": "Agendar",
        "handoff": "Transferir a un agente",
        "ask_name": "Pedir el nombre nuevamente",
        "capture_name": "Capturar nombre",
        "offhours_reply": "Responder fuera del horario"
      },
      "preview": {
        "company": "Empresa Ejemplo",
        "customer": "María Cliente",
        "agent": "Carlos Vendedor",
        "message": "Hola, necesito ayuda con un SUV."
      },
      "notifications": {
        "load_error": "No se pudo cargar la configuración del bot.",
        "saved": "Configuración del bot guardada correctamente.",
        "save_error": "No se pudo guardar la configuración del bot.",
        "bootstrap_success": "Flujo predeterminado aplicado correctamente.",
        "bootstrap_error": "No se pudo aplicar el flujo predeterminado."
      }
    },
    "tabs": {
      "overview": "Vista general",
      "config": "Configuración",
      "operations": "Conversaciones y decisiones",
      "diagnostics": "Diagnóstico"
    },
    "engines": { "none": "Ninguno", "rules": "Flujo por reglas", "orchestrator": "Flujo inteligente" },
    "outcomes": {
      "replied": "Respondió",
      "skipped": "Ignoró",
      "handoff": "Transfirió a un agente",
      "error": "Error",
      "no_reply": "Sin respuesta"
    },
    "statuses": { "operating": "Operando", "paused": "Pausado", "partial": "Parcial", "error": "Con error" },
    "llm_statuses": {
      "active": "Activa",
      "canary": "En piloto",
      "unavailable": "No disponible",
      "not_enabled": "No habilitada"
    },
    "readiness": {
      "healthy": "Normal",
      "degraded": "Degradada",
      "unavailable": "No disponible",
      "unknown": "Desconocida"
    },
    "status": {
      "automatic_service": "Atención automática",
      "answers_now": "¿Atiende ahora?",
      "in_business_hours": "Dentro del horario comercial",
      "outside_business_hours": "Fuera del horario comercial",
      "main_flow": "Flujo principal",
      "continuity_available": "Continuidad por reglas disponible",
      "continuity_unavailable": "Sin continuidad configurada",
      "calls_today": "{calls} / {limit} llamadas hoy",
      "calculated_at": "Estado calculado el {date}",
      "last_execution": "Última ejecución",
      "view_conversation": "Ver conversación"
    },
    "analytics": {
      "title": "Indicadores",
      "loading": "Cargando indicadores...",
      "error": "No se pudieron cargar los indicadores.",
      "empty": "Sin datos para el período.",
      "stale": "Los indicadores aún no están consolidados para este período.",
      "partial": "Algunos días aún se están consolidando; los números pueden variar.",
      "today": "Hoy",
      "days_7": "7 días",
      "days_30": "30 días",
      "orchestrator": "Orquestador",
      "success": "éxito",
      "continuity": "continuidad",
      "errors": "Errores",
      "calls": "llamadas",
      "uses": "usos",
      "latency": "Latencia p50/p95",
      "inbound_evaluated": "Entradas evaluadas",
      "automated_replies": "Respuestas automáticas",
      "automation_rate": "Tasa de automatización",
      "handoffs": "Transferencias",
      "no_reply": "Sin respuesta"
    },
    "flow": {
      "title": "Tratamiento del mensaje",
      "policy": "Política y horario",
      "policy_detail": "Verifica si la atención automática debe responder ahora.",
      "smart_primary": "Flujo inteligente (principal)",
      "rules_primary": "Flujo por reglas (principal)",
      "smart_detail": "Entiende el mensaje y decide la mejor respuesta.",
      "rules_detail": "Aplica las reglas configuradas de la empresa.",
      "ai": "IA asistiva cuando sea necesario",
      "ai_detail": "La IA solo se llama cuando las reglas no entienden el mensaje.",
      "tools": "Inventario y citas",
      "tools_detail": "Consulta el inventario y agenda visitas cuando se solicita.",
      "delivery": "Respuesta o agente",
      "delivery_detail": "Envía la respuesta automática o transfiere a un agente.",
      "continuity": "Si falla el flujo principal, la atención continúa mediante el flujo por reglas."
    },
    "diagnostics": {
      "health": "Salud y continuidad",
      "readiness": "Disponibilidad del flujo inteligente",
      "observed_at": "observado el {date}",
      "no_heartbeat": "sin señal reciente",
      "rules_continuity": "Continuidad por reglas",
      "recent_window": "Ventana reciente (24h)",
      "recent_values": "{total} ejecuciones · {errors} errores · {fallbacks} continuidades",
      "rollout_source": "Origen del rollout",
      "platform": "Gobernado por la plataforma",
      "legacy": "Configuración heredada",
      "ai_usage": "Uso de IA asistiva",
      "state": "Estado",
      "classify": "Comprensión (classify)",
      "rewrite": "Naturalización (rewrite)",
      "daily_usage": "Consumo diario",
      "calls": "{calls} / {limit} llamadas",
      "stage": "Etapa"
    },
    "executions": {
      "title": "Conversaciones y decisiones",
      "search": "Buscar por lead o teléfono",
      "outcome": "Resultado",
      "engine": "Motor",
      "ai_used": "IA usada",
      "with_ai": "Con IA",
      "without_ai": "Sin IA",
      "protection": "Protección",
      "protection_applied": "Protección aplicada",
      "protection_not_applied": "Sin protección aplicada",
      "date_from": "Fecha inicial",
      "date_to": "Fecha final",
      "loading": "Cargando ejecuciones...",
      "error": "No se pudieron cargar las ejecuciones.",
      "empty": "Ninguna ejecución coincide con el período o los filtros.",
      "caption": "Ejecuciones de la atención automática",
      "date_time": "Fecha/hora",
      "lead": "Lead",
      "message": "Mensaje",
      "action": "Acción",
      "latency": "Latencia",
      "details": "Detalles",
      "inventory": "Inventario",
      "schedule": "Agenda"
    },
    "drawer": {
      "title": "Entender esta respuesta",
      "loading": "Cargando explicación...",
      "error": "No se pudo cargar esta ejecución.",
      "empty_trace": "Esta ejecución no tiene etapas registradas.",
      "technical": "Detalles técnicos",
      "execution": "Ejecución",
      "communication": "Comunicación",
      "status": "Estado",
      "attempts": "Intentos",
      "confidence": "Confianza",
      "ai_path": "Ruta de IA",
      "ai_calls": "Llamadas de IA",
      "latency": "Latencia",
      "engine_value": "motor: {value}",
      "tool_value": "herramienta: {value}",
      "confidence_value": "confianza: {value}",
      "tools": { "inventory_search": "consulta de inventario", "schedule_visit": "programación de visita" },
      "confidence_bands": { "low": "baja", "medium": "media", "high": "alta" },
      "results": "{count} resultado(s)",
      "steps": {
        "policy": "Política y horario",
        "engine": "Motor de atención",
        "intent": "Comprensión del mensaje",
        "tool": "Consulta de inventario",
        "schedule": "Cita",
        "guardrail": "Protección de respuesta",
        "handoff": "Transferencia a un agente",
        "delivery": "Entrega de la respuesta"
      },
      "step_outcomes": {
        "allowed": "permitido",
        "blocked": "bloqueado",
        "skipped": "ignorado",
        "selected": "seleccionado",
        "fallback": "continuidad activada",
        "requested": "solicitado",
        "sent": "enviada",
        "no_reply": "sin respuesta",
        "applied": "aplicada",
        "failed": "falló"
      }
    },
    "chat": {
      "automatic": "Automática",
      "automatic_label": "Enviada por la atención automática",
      "guardrail": "Protección de respuesta aplicada",
      "explain_action": "Entender atención automática",
      "no_auto_reply": "Sin respuesta automática",
      "no_execution": "Este mensaje no tiene una ejecución explicable.",
      "imported_history": "Historial importado"
    },
    "reasons": {
      "bot_disabled": "La atención automática fue desactivada por un administrador.",
      "policy_never": "La política de la empresa nunca permite respuestas automáticas.",
      "policy_blocked": "La política actual no permite una respuesta automática ahora.",
      "outside_business_hours": "Fuera del horario comercial.",
      "inside_business_hours": "Dentro del horario comercial.",
      "new_lead_off_hours_override": "Un lead nuevo fue atendido fuera del horario mediante la excepción habilitada.",
      "human_already_assigned": "La conversación ya está asignada a un agente humano.",
      "missing_contact_key": "El contacto no tiene teléfono o identificador para responder.",
      "orchestrator_disabled": "El flujo inteligente está desactivado para esta empresa.",
      "orchestrator_timeout": "El flujo inteligente tardó demasiado; continuamos por las reglas.",
      "orchestrator_unavailable": "El flujo inteligente no está disponible; continuamos por las reglas.",
      "orchestrator_contract_error": "El flujo inteligente devolvió una respuesta inesperada; continuamos por las reglas.",
      "rules_fallback": "La atención continuó automáticamente mediante las reglas.",
      "no_rule_matched": "Ninguna regla entendió el mensaje.",
      "rules_replied": "Respondido por el flujo de reglas.",
      "llm_not_needed": "La IA asistiva no fue necesaria.",
      "llm_disabled": "La IA asistiva está desactivada.",
      "llm_budget_exhausted": "La IA asistiva alcanzó su límite diario; continuamos por el flujo seguro.",
      "llm_breaker_open": "La IA asistiva no está disponible temporalmente; se mantuvo el flujo seguro.",
      "llm_schema_invalid": "La respuesta de IA fue descartada por seguridad; se mantuvo el flujo seguro.",
      "llm_low_confidence": "La confianza de IA fue baja; se mantuvo el flujo determinista.",
      "llm_success": "La IA ayudó a comprender el mensaje.",
      "llm_fallback_success": "La IA asistiva respondió mediante la continuidad.",
      "guardrail_rewrite": "Se aplicó protección a la respuesta generada.",
      "guardrail_commercial": "Se aplicó protección comercial a la respuesta.",
      "inventory_ok": "El inventario devolvió opciones disponibles.",
      "inventory_empty": "El inventario no devolvió opciones disponibles.",
      "inventory_unavailable": "La consulta de inventario no está disponible.",
      "schedule_created": "Visita agendada.",
      "schedule_already_exists": "La visita ya estaba agendada.",
      "schedule_failed": "No se pudo agendar la visita.",
      "handoff_requested": "Se solicitó transferencia a un agente.",
      "delivery_failed": "No se pudo enviar la respuesta.",
      "idempotency_hit": "Se ignoró un mensaje repetido porque ya había sido procesado.",
      "engine_error": "No se pudo procesar el mensaje."
    }
  },
  "auth": {
    "agree": "Acepto",
    "createAccount": "Crear cuenta",
    "createNewAccount": "Crear cuenta nueva",
    "email": "Email",
    "login": "Iniciar sesión",
    "password": "Contraseña",
    "recover_password": "Recuperar contraseña",
    "sign_up": "Registrar",
    "keep_logged_in": "Mantenerme conectado",
    "termsOfUse": "Términos de uso",
    "reset_password": "Restablecer contraseña"
  },
  "404": {
    "title": "Esta página se ha ido a pescar",
    "text": "Si crees que esto no es correcto, por favor envíanos un mensaje a ",
    "back_button": "Volver al tablero"
  },
  "typography": {
    "primary": "Estilos de texto primarios",
    "secondary": "Estilos de texto secundarios"
  },
  "dashboard": {
    "versions": "Versiones",
    "setupRemoteConnections": "Configurar conexiones remotas",
    "currentVisitors": "Visitantes actuales",
    "charts": {
      "trendyTrends": "Tendencias modernas",
      "showInMoreDetail": "Mostrar en más detalle",
      "showInLessDetail": "Mostrar en menos detalle",
      "loadingSpeed": "Velocidad de carga",
      "topContributors": "Principales contribuyentes",
      "showNextFive": "Mostrar los siguientes cinco",
      "commits": "Commit"
    },
    "info": {
      "componentRichTheme": "Tema rico en componentes",
      "completedPullRequests": "Solicitudes de pull completadas",
      "users": "Usuarios",
      "points": "Puntos",
      "units": "Unidades",
      "exploreGallery": "Explorar galería",
      "viewLibrary": "Ver biblioteca",
      "commits": "Commits",
      "components": "Componentes",
      "teamMembers": "Miembros del equipo"
    },
    "tabs": {
      "overview": {
        "title": "Visión general",
        "built": "Construido con el framework Vue.js",
        "free": "Totalmente gratuito para todos",
        "fresh": "Diseño fresco y nítido",
        "mobile": "Responsivo y optimizado para móviles",
        "components": "Toneladas de componentes útiles",
        "nojQuery": "Totalmente libre de jQuery"
      },
      "billingAddress": {
        "title": "Dirección de facturación",
        "personalInfo": "Información personal",
        "firstName": "Nombre y apellido",
        "email": "Email",
        "address": "Dirección",
        "companyInfo": "Información de la empresa",
        "city": "Ciudad",
        "country": "País",
        "infiniteConnections": "Conexiones infinitas",
        "addConnection": "Añadir conexión"
      },
      "bankDetails": {
        "title": "Detalles del banco",
        "detailsFields": "Campos de detalles",
        "bankName": "Nombre del banco",
        "accountName": "Nombre de la cuenta",
        "sortCode": "Código de ordenación",
        "accountNumber": "Número de cuenta",
        "notes": "Notas",
        "sendDetails": "Enviar detalles"
      }
    },
    "navigationLayout": "Diseño de navegación",
    "topBarButton": "Barra superior",
    "sideBarButton": "Barra lateral"
  },
  "language": {
    "brazilian_portuguese": "Portugués brasileño",
    "english": "Inglés",
    "spanish": "Español",
    "simplified_chinese": "Chino simplificado",
    "persian": "Persa"
  },
  "menu": {
    "auth": "Autenticación",
    "buttons": "Botones",
    "timelines": "Líneas de tiempo",
    "dashboard": "Tablero",
    "billing": "Facturación",
    "login": "Iniciar sesión",
    "preferences": "Preferencias",
    "payments": "Pagos",
    "pricing-plans": "Planes de precios",
    "login-singup": "Iniciar sesión/Registrarse",
    "404": "Páginas 404",
    "faq": "FAQ",
    "crm": "Atención",
    "agenda": "Agenda",
    "tarefas": "Tareas",
    "oportunidades": "Oportunidades",
    "negociacao": "Negociaciones",
    "propostas": "Propuestas",
    "kanban": "Kanban",
    "dashboard_negociacao": "Panel",
    "template": "Plantillas",
    "bot_atendimento": "Bot de Atención",
    "storage": "Almacenamiento",
    "painel": "Panel de Atención",
    "contato": "Contactos",
    "reports": "Reportes",
    "reports_general": "Reportes Generales",
    "reports_templates": "Plantillas",
    "reports_executions": "Ejecuciones",
    "businessHour": "Horario de Atención",
    "demos": "Demos",
    "leadContactDemo": "Leads y Contactos",
    "leadTest": "LeadTest",
    "company": "Empresa",
    "company_overview": "Datos de la Empresa",
    "user": "Usuarios",
    "client": "Cliente",
    "settings": "Configuración",
    "available": "Disponibles",
    "sold": "Vendidos",
    "sales": "Ventas",
    "sales_list": "Lista",
    "sales_new": "Nueva venta"
  },
  "messages": {
    "all": "Ver todos los mensajes",
    "new": "Nuevos mensajes de {name}",
    "mark_as_read": "Marcar como leído"
  },
  "navbar": {
    "messageUs": "Preguntas sobre desarrollo web:",
    "repository": "Repositorio GitHub"
  },
  "notifications": {
    "all": "Ver todas las notificaciones",
    "mark_as_read": "Marcar como leída",
    "sentMessage": "{name} te envió un mensaje",
    "uploadedZip": "{name} subió un archivo Zip con {type}",
    "startedTopic": "{name} inició un nuevo tema"
  },
  "user": {
    "language": "Cambiar Idioma",
    "logout": "Cerrar sesión",
    "profile": "Mi Perfil",
    "settings": "Configuración",
    "billing": "Facturación",
    "faq": "Preguntas Frecuentes",
    "helpAndSupport": "Ayuda & Soporte",
    "projects": "Proyectos",
    "account": "Cuenta",
    "explore": "Explorar",
    "automations_processes": "Automatizaciones / Procesamientos"
  },
  "helpAndSupport": "Ayuda y Soporte",
  "aboutVuesticAdmin": "Acerca de Vuestic Admin",
  "search": {
    "placeholder": "Buscar..."
  }
}
